import { ReactNode } from 'react';
import { useLogger, useServices } from '@packages/shared/core/common/hooks';
import { calculateAges } from '@packages/shared/core/common/utils/calculateAges';
import { useQuizStep } from '@packages/shared/core/quiz/hooks';
import { DateStepData, QuizScreenProps } from '@packages/shared/core/quiz/entities';

type DateQuizStepProps = {
  id: string;
  renderQuizScreen: (stepData: QuizScreenProps) => ReactNode;
};

const DateQuizStep = ({ id, renderQuizScreen }: DateQuizStepProps) => {
  const logger = useLogger();
  const { analyticsService } = useServices();
  const { back, next, stepData, updateUserPreferences, updateUserInteraction, totalSteps, stepOrder } = useQuizStep(id);

  if (!stepData) {
    // TODO add fallback
    logger.error(new TypeError(`Data for ${id} step not found`));
    return null;
  }

  const { dataKey } = stepData as DateStepData;

  const goBack = async () => back();

  const onDateSelected = async (date: string) => {
    const userAge = calculateAges(date);

    analyticsService.trackUserAge(userAge);

    updateUserPreferences(dataKey, date);

    await next(date);
  };

  const onChange = () => {
    updateUserInteraction(dataKey);
  };

  return (
    <>
      {renderQuizScreen({
        onBack: goBack,
        onSubmit: onDateSelected,
        onChange,
        totalSteps,
        stepOrder,
        ...(stepData as DateStepData),
      })}
    </>
  );
};

export default DateQuizStep;
